import './lesson_component.css'
import { Controller } from 'stimulus'
import { lockScroll, unlockScroll } from '~/common/helpers/scroll_lock'

export default class extends Controller {
  static targets = ['mainContent']

  showTranscript(e) {
    this.ignoreAssetEl = true
    this.dispatch('assetChanged', {
      detail: { assetId: e.params.assetId },
      target: this.lessonTabs,
    })
    this.#activateTab('transcript')
    this.#openBottomSheet()
  }

  showBookmark(e) {
    this.ignoreAssetEl = true
    this.dispatch('assetChanged', {
      detail: { assetId: e.params.assetId },
      target: this.lessonTabs,
    })
    this.#activateTab('bookmarks')
    this.#openBottomSheet()
  }

  bottomSheetWillOpen(event) {
    if (!event.target.contains(this.bottomSheetContent)) return
    document.body.classList.add('lesson-bottom-sheet-open')

    const asset = this.ignoreAssetEl
      ? null
      : this.lastPlayedAssetEl || this.firstPlayableAssetEl

    if (asset) {
      this.#scrollTo(asset)
    }

    const viewportHeight = window.innerHeight
    const bottomSheetHeight = asset
      ? viewportHeight - asset.offsetHeight
      : 0.6 * viewportHeight
    this.bottomSheetContent.style.height = `${bottomSheetHeight}px`

    // Lock after the scrollBy above lands — otherwise iOS auto-scrolls the
    // document into the 100vh runway every time the keyboard opens, and never
    // scrolls back when it closes.
    lockScroll()

    this.ignoreAssetEl = false
  }

  bottomSheetWillClose(event) {
    if (!event.target.contains(this.bottomSheetContent)) return
    unlockScroll()
    document.body.classList.remove('lesson-bottom-sheet-open')
  }

  closeBottomSheetOnDesktop() {
    if (window.innerWidth > 1024) {
      this.dispatch('bottom-sheet:destroy', {
        target: this.bottomSheetContent,
        prefix: false,
        bubbles: true,
      })
    }
  }

  activateTabAndShowBottomSheet(e) {
    const tab = e.target.closest('[data-lesson-tab]')

    if (tab) this.#activateTab(tab.dataset.lessonTab)

    this.dispatch('bottom-sheet:open', {
      target: this.bottomSheetContent,
      prefix: false,
    })
  }

  assetPlayed(e) {
    this.lastPlayedAssetEl = e.target.closest('.video-js')
  }

  get firstPlayableAssetEl() {
    return this.element.querySelector('.video-js')
  }

  // This is intentionally not a target because it is moved by the bottom bottom sheet
  // Currently, we keep it where it is. But that might not be true in the future and it might move outside this controller's element
  get bottomSheetContent() {
    return this.element.querySelector('.js-lesson-bottom-sheet-content')
  }

  get lessonTabs() {
    return document.querySelector('.js-lesson-tabs')
  }

  #scrollTo(element) {
    const top = element.getBoundingClientRect().top + 1
    window.scrollBy({ top, behavior: 'instant' })
  }

  #activateTab(tabName) {
    this.lessonTabs.querySelector(`[data-lesson-tab="${tabName}"]`)?.click()
  }

  #openBottomSheet() {
    // Trigger the even on lesson tabs, so it only opens if the lesson tabs are in the bottom sheet
    this.dispatch('bottom-sheet:open', {
      target: this.lessonTabs,
      prefix: false,
    })
  }
}
